export function getAbsolutePathUrl(str) {
    if (!str) return str;
    const linkRegex = /href="~\/link.aspx/g;
    const linkReplace = `href="${ process.env.VUE_APP_CM_URL }/link.aspx`;
    const mediaRegex = /src="-\/media\//g;
    const mediaReplace = `src="${ process.env.VUE_APP_CM_URL }/-/media/`;

    const urlsChanged = str.replace(linkRegex, linkReplace);
    return urlsChanged.replace(mediaRegex, mediaReplace);
}
